<template>
  <div>
    <div class="row justify-content-center">
       <div class="col-10">
                <div class="text-left section-title" style="padding: 5px;">
                <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>Providers</span>
                </div>
            </div>
     
    </div>

    <div class="row" style="padding-left: 15px; padding-right: 15px;">
      <div class="col-6 offset-3">
          <div class="container form-background">
              <div class="row">
                  <div class=" col-12 text-left form-title">
                      <span class="row-table-font-margins">{{ formTitle }} for building {{ buildingName }}</span>
                  </div>
              </div>

              <div class="row">
                  <div class="col-md-6">
                      <label>Name: *</label>
                      <input type="text" v-model="name" placeholder="Name" class="form-control" />
                      <div v-show="submitted && !name" class="invalid-feedback">
                          Name is required
                      </div>
                  </div>
                  <div class="col-md-6">
                      <label>Service types:</label>
                      <!--<ejs-multiselect class="form-control"
                     v-model="serviceTypes"
                     id="multiselect"
                     :dataSource="options"
                     :fields="fields"
                     mode="CheckBox"
                     allowFiltering="true"
                     filterBarPlaceholder="Search Service Types"
                     showSelectAll="true"
                     placeholder="Select Service Types"></ejs-multiselect>-->
                      <VueMultiselect :multiple="true"
  :close-on-select="true" label="name" track-by="name" v-model="serviceTypes"
                                      :options="options">
                      </VueMultiselect>
                      <div v-if="submitted && serviceTypes.length <=0" class="invalid-feedback d-block">
                          Please assign a service type to the supplier
                      </div>
                  </div>
              </div>

              <div class="row">
                  <div class="col-md-6">
                      <label>Phone Number: </label>
                      <input type="text" v-model="phoneNumber" placeholder="Phone Number" class="form-control" />
                  </div>
                  <div class="col-md-6">
                      <label>Website: </label>
                      <input type="text" placeholder="E-mail" v-model="website" class="form-control" />
                  </div>
              </div>

              <div class="row">
                  <div class="col-md-6">
                      <label>Contact Person First Name: </label>
                      <input type="text" placeholder="First Name" v-model="firstName" class="form-control" />
                  </div>
                  <div class="col-md-6">
                      <label>Contact Person Surname:</label>
                      <input type="text" v-model="surname" placeholder="Surname" class="form-control" />
                  </div>
              </div>

              <div class="row">
                  <div class="col-md-6">
                      <label>Email: </label>
                      <input type="text" placeholder="E-mail" v-model="email" class="form-control" />
                  </div>
                  <div class="col-md-6">
                      <label>Fax:</label>
                      <input type="text" v-model="fax" placeholder="Fax" class="form-control" />
                  </div>
              </div>


              <input type="hidden" name="user_id" value="user_id" />
              <section id="complexes" style="display: none;"></section>
          </div>
         <div class="text-right">
          <button type="submit"
            @click.prevent="saveSupplier()" class="btn btn-submit" style="margin: 15px;">
            Submit
          </button>
          <button @click="cancel()" class="btn btn-cancel">Cancel</button>
        </div>
      </div>
     
    </div>
  </div>


  
</template>

<script>
import { expenseTypeService } from "@/_services";
    import { mapState } from "vuex";
    import VueMultiselect from 'vue-multiselect'
    import { redirectToBuildingList } from "@/_helpers/list-redirect";
    export default {
        components: { VueMultiselect },
  data: function () {
    return {
      name: "",
      fax: "",
      website: "",
        phoneNumber: "",
        firstName: "",
      surname:"",
      serviceTypes: [],
      email: "",
      position: 1,
      id: 0,
      submitted: false,
      formTitle: "Add new provider",
      buildingId: 0,
     // buildingName: "",
      submitButtonText: "Submit",
      fields: { text: "name", value: "id" },
        options: [],
        expenseTypeIds: [
            
        ],
    };
  },
  mounted() {
    if (redirectToBuildingList(this, "suppliers")) return;
  //  this.buildingName = this.$route.params.buildingName;

    if (this.$route.params.id) {
      this.formTitle = "Update provider";
      this.submitButtonText = "Update";
      this.buildingId = this.$route.params.buildingId;
      this.id = this.$route.params.id;
      this.getServiceTypes();
      this.getSupplier();
    } else {
      this.buildingId = this.$route.params.buildingId;
      this.getServiceTypes();
    }
  },
  methods: {
    cancel() {
      this.$router.push({
        name: "suppliers",
        params: { buildingId: this.buildingId },
      });
    },
    getServiceTypes: function () {
      this.mute = true;
      //this.buildingId = 3;
      expenseTypeService
        .getExpenseTypesOfBuilding(this.buildingId)
        .then((data) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.options = data.expenseTypes;
        });
    },
    getSupplier: function () {
      this.$http.get("/suppliers/" + this.id).then((response) => {
        (this.buildingId = response.data.buildingId),
          // this.buildingName = response.data.building.name,
          (this.name = response.data.name);
          this.serviceTypes = response.data.expenseTypes;
        this.phoneNumber = response.data.phoneNumber;
        this.fax = response.data.fax;
        this.website = response.data.website;
          this.email = response.data.email;
          this.firstName = response.data.firstName;
          this.surname = response.data.surname;
      });
    },
      saveSupplier: function () {
          this.expenseTypeIds = []
          for (let i = 0; i < this.serviceTypes.length; i++) {
              this.expenseTypeIds.push(this.serviceTypes[i].id)
          }
       // console.log(this.serviceTypes)
      var canSubmit = this.name && this.serviceTypes.length > 0;
      if (this.id) {
        this.submitted = true;
        if (canSubmit)
          this.$http
            .put("/suppliers/" + this.id, {
              id: this.id,
              name: this.name,
              website: this.website,
              email: this.email,
                fax: this.fax,
                firstName: this.firstName,
                surname: this.surname,
              phoneNumber: this.phoneNumber,
                expenseTypeIds: this.expenseTypeIds,
              buildingId: this.buildingId,
            })
            .then(
              () => {
                this.$router.push({
                  name: "suppliers",
                  params: { buildingId: this.buildingId },
                });
              },
              () => {
                alert("error");
                //  this.infoError = true
                //  this.loader = false
                //   this.password = ''
              }
            );
      } else {
        //return
        this.submitted = true;
        if (canSubmit)
          this.$http
            .post("/suppliers", {
              name: this.name,
              website: this.website,
              email: this.email,
                fax: this.fax,
                firstName: this.firstName,
                surname: this.surname,
              phoneNumber: this.phoneNumber,
                expenseTypeIds: this.expenseTypeIds,
              buildingId: this.buildingId,
            })
            .then(
              () => {
                this.$router.push({
                  name: "suppliers",
                  params: { buildingId: this.buildingId },
                });
              },
              () => {
                alert("error");
                //  this.infoError = true
                //  this.loader = false
                //   this.password = ''
              }
            );
      }
    },
  },
  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
  },
  // Our Javascript logic
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>